import { QueryFactory } from "../../../../Common";
export const QDeclineNewOffer = QueryFactory("DeclineCashOutBetNewOffer");
//# sourceMappingURL=QDeclineNewOffer.js.map